import xws from 'api/xws/';
import qs from 'query-string';
import { deleteVehicleWs } from 'api/xws/vehicle/deleteVehicleWs';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';
import { setCustomerVehicle } from 'store/reducers/appointment/actions';
import { removeUserVehicle } from 'store/reducers/user/personInfo/actions';

// Selectors
import { getWebkey, getQueryParam } from 'store/reducers/queryParams/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

// Constants
import { getService } from 'constants/ajax';
import { VEHICLE_VALUES } from 'constants/vehicle';

export const getDecodeVIN = vin => async (dispatch, getState) => {
  if (!vin || vin.length !== 17) {
    return false;
  }
  const vinService = getService('vin');
  const webKey = getWebkey(getState());
  const locale = getLocaleCode(getState());
  vinService.setPathVars({ vin });
  vinService.setCallBacks(dispatch(ajaxCallbacks()));
  const request = xws(vinService).get(vinService.getPath(), {
    params: {
      webKey,
      locale
    }
  });
  try {
    const {
      data: {
        vehicleInfo: {
          driveTypeBase,
          engineSizeBase,
          engineTypeBase,
          transmissionTypeBase,
          trimBase,
          modelBase,
          model,
          ...vehicleData
        }
      }
    } = await request;
    return {
      ...vehicleData,
      driveType: driveTypeBase,
      engineSize: engineSizeBase,
      engineType: engineTypeBase,
      transmissionType: transmissionTypeBase,
      model: modelBase || model,
      trim: trimBase
    };
  } catch (e) {
    /* eslint-disable no-console */
    console.log(e);
    /* eslint-enable no-console */
    return false;
  }
};

// TODO: refactor, use this instead src/store/reducers/appointment/actions.js:208
// TODO: also src/store/reducers/appointment/actions.js:208 is called several times,
// TODO: the correct behavior should be call it one time and then use a selector
export const getMetaVehicleId = ({ make, year, model, ...vehicle }) => async (
  dispatch,
  getState
) => {
  const metaVehicleIdService = getService('metaVehicle');
  const webkey = getWebkey(getState());
  const { OTHER } = VEHICLE_VALUES;
  let vehicleTemp;
  if (make === OTHER && model === OTHER) {
    vehicleTemp = { make, year, model };
  } else {
    vehicleTemp = { make, year, model, ...vehicle };
  }
  metaVehicleIdService.setPathVars({ webkey });
  metaVehicleIdService.setCallBacks(dispatch(ajaxCallbacks()));
  const {
    data: {
      // eslint-disable-next-line no-unused-vars
      data: { id }
    }
  } = await xws(metaVehicleIdService).post(
    metaVehicleIdService.getPath(),
    qs.stringify(vehicleTemp)
  );
  // dispatch(setMetaVehicleId(id));
};

export const setDecodedVINtoAppt = decodeVIN => async (dispatch, getState) => {
  const regDate = getQueryParam('registration_date')(getState());
  await dispatch(
    setCustomerVehicle({
      mileage: getQueryParam('mileage')(getState()),
      ...{ regDate },
      ...decodeVIN
    })
  );
};

export const deleteVehicle = vehicleId => async (dispatch, getState) => {
  const webkey = getWebkey(getState());
  const authId = getTokenId(getState());
  try {
    const { data } = await deleteVehicleWs({
      webkey,
      authId,
      vehicleId
    });
    if (data.success) {
      dispatch(removeUserVehicle(vehicleId));
    }
    return data;
  } catch (err) {
    /* eslint-disable no-console */
    console.error(err);
    /* eslint-enable no-console */
    return { success: false };
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/vehicle/actions.js